const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/ab690276bcb622f20271f473c7c9240f.jpg')`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20 text-white">
        <div className="max-w-3xl">
          <div className="inline-block px-4 py-1.5 bg-white/20 backdrop-blur-sm border border-white/50 rounded-full text-sm mb-6 font-medium">
            Costa del Sol | Estepona
          </div>

          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold leading-tight mb-6 drop-shadow-2xl">
            Expertos en hormigón decorativo
            <br />
            <span className="text-[#1E90FF] drop-shadow-lg">y piscinas de arena</span>
            <br />
            en la Costa del Sol
          </h1>

          <p className="text-lg md:text-xl text-white mb-3 font-medium drop-shadow-lg">
            Hormigón impreso • Hormigón desactivado • Hormigón pulido
          </p>
          <p className="text-lg md:text-xl text-white mb-10 font-medium drop-shadow-lg">
            Piscinas Arelite® con efecto playa natural
          </p>

          <div className="flex flex-col sm:flex-row flex-wrap gap-4">
            <a
              href="#presupuesto"
              className="inline-flex items-center justify-center gap-2 px-8 md:px-10 py-4 bg-[#1E90FF] text-white rounded-full font-semibold hover:bg-[#1873CC] transition-all hover:gap-3 cursor-pointer whitespace-nowrap shadow-2xl hover:shadow-[#1E90FF]/50"
            >
              Solicitar Presupuesto
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-lg"></i>
              </div>
            </a>

            <a
              href="https://wa.me/34640877479"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-8 md:px-10 py-4 bg-[#25D366] text-white rounded-full font-semibold hover:bg-[#20BA5A] transition-colors cursor-pointer whitespace-nowrap shadow-2xl hover:shadow-[#25D366]/50"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-whatsapp-line text-lg"></i>
              </div>
              Contactar por WhatsApp
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-6 flex items-center justify-center text-white/80">
          <i className="ri-arrow-down-line text-2xl drop-shadow-lg"></i>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
